module.exports = __webpack_public_path__ + "static/media/western.7468dc58.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/western.svg
// module id = 330
// module chunks = 0